import { IOccupancyDetails } from 'modules/lite/reservations/models';
import API from 'services/api';

export const getOccupancyDetails = (unitOccupancyId: string): Promise<IOccupancyDetails> => {
  return API.get(`/api/renter/accommodation/occupancies/${unitOccupancyId}`).then(
    response => response?.data,
  );
};
